import { SurveyType } from '../../../../../../models/SurveySchema'
import { RCNMidYearSummary } from './RCNMidYearSummary'
import { ISDMidYearSummary } from './ISDMidYearSummary'
import { SurveyPdfReportShell } from './SurveyPdfReportShell'
import { type SurveySchema } from '../../../../../../models/SurveySchema'

export interface SurveyElement {
  type: string
  name: string
  title?: string
  text?: string
  variant?: string
  description?: string
  choices?: string[]
  radioMatrix?: Record<string, { hasUpload?: boolean, hasTextInput?: boolean, infoText?: string }> | null
  visibleIf?: string | null
  templateElements?: SurveyElement[]
  conditionalRenderKey?: string | null
}

export interface SurveyPage {
  title: string
  elements: SurveyElement[]
}

export interface SurveyContent {
  title: string
  pages: SurveyPage[]
}

export const MidYearSummary = ({ initialSurvey }: { initialSurvey: SurveySchema }): JSX.Element => {
  const content: SurveyContent = JSON.parse(initialSurvey.content)
  const answers: Record<string, any> = initialSurvey.answers != null ? JSON.parse(initialSurvey.answers) : {}

  if (content == null) return <div>No MidYear Summary found</div>

  return (
    <SurveyPdfReportShell
      title='Mid-Year Progress Report Submission'
      pdfElementId='midyear-summary-pdf'
      cardTestId='midYearSummaryCard'
      exportButtonTestId='exportPdfButton'
    >
      {(forceExpanded) => (
        initialSurvey.id === SurveyType.RCNMidYear
          ? <RCNMidYearSummary content={content} answers={answers} />
          : <ISDMidYearSummary content={content} answers={answers} forceExpanded={forceExpanded} />
      )}
    </SurveyPdfReportShell>
  )
}
